import { createFileRoute, redirect } from '@tanstack/react-router';
import { api, ApiError } from '../lib/api';
import { useAuthStore } from '../lib/auth-store';
import { ROLE_LANDING_PATH } from '../components/nav';

/**
 * Root entry point. When authenticated, route the user to *their* landing
 * page (queue-first IA) rather than a generic dashboard. When not, send
 * them to /login.
 *
 * The role → landing mapping is the single source of truth declared in
 * `components/nav.ts` — keep it in sync there, not here.
 */
export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    try {
      const me = await api.me();
      useAuthStore.getState().setUser(me);
      const target = ROLE_LANDING_PATH[me.primaryRole] ?? '/dashboard';
      throw redirect({ to: target });
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        throw redirect({ to: '/login' });
      }
      throw err;
    }
  },
});
